import React, { Component } from 'react';
import Iterator from '../core/Iterator';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class Scene360LayerChoice {
	constructor(props){
		const {slug}=props;
		if(slug ===undefined)
			throwNotProvided('slug');
		this._slug = slug;
	}
	get slug(){
		return this._slug;
	}
}
